import React, { CSSProperties } from 'react'
import NextLink from 'next/link'
import { EmtButton, EmtButtonProps } from 'emt-components-v2'

type LinkButtonProps = Omit<EmtButtonProps, 'variant'> & {
  href?: string
  forceExternal?: boolean
  variant: any
  aStyle?: CSSProperties
}

const LinkButton: React.FC<LinkButtonProps & any> = ({ href, forceExternal = false, aStyle, onClick, ...rest }) => {
  if (!href?.length || href === '#') {
    if (!onClick) {
      return null
    }

    return <EmtButton onClick={onClick} {...rest} />
  }

  let targetProps = {}
  if (forceExternal || href?.startsWith('http')) {
    targetProps = { target: '_blank', rel: 'noopener noreferrer' }

    return (
      <a href={href} onClick={onClick} {...targetProps} style={{ textDecoration: 'none', ...aStyle }}>
        <EmtButton {...rest} />
      </a>
    )
  }

  return (
    <NextLink href={href} passHref legacyBehavior>
      <EmtButton onClick={onClick} {...rest} />
    </NextLink>
  )
}

export default LinkButton
